import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    NgZone,
    OnChanges,
    Output,
    Renderer2,
    SimpleChanges,
    ViewEncapsulation,
} from "@angular/core"
import ResourceUtils from "../../utils/resource-utils"
import { CHNode } from "../../models/node.model"
import { SwiperOptions } from "swiper/types"

// import Swiper core and required modules
import SwiperCore, { Autoplay, EffectCoverflow, Navigation } from "swiper/core"

// Use Swiper modules
SwiperCore.use([Navigation, EffectCoverflow, Autoplay])

@Component({
    selector: "app-vertical-menu",
    templateUrl: "./vertical-menu.component.html",
    styleUrls: ["./vertical-menu.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class VerticalMenuComponent implements AfterViewInit, OnChanges {
    @Input() subjectTree: CHNode[]
    @Input() swiperOptions: SwiperOptions
    @Input() showNavigation: boolean

    @Output() selectedSubject: EventEmitter<any> = new EventEmitter()

    getSubjectColor = ResourceUtils.getSubjectColor
    subjectSelected = false

    swiperButtonPrev: HTMLElement
    swiperButtonNext: HTMLElement

    constructor(private zone: NgZone, private elem: ElementRef, private renderer: Renderer2) {}

    ngAfterViewInit(): void {
        this.swiperButtonPrev = this.elem.nativeElement.querySelector(".swiper-button-prev")
        this.swiperButtonNext = this.elem.nativeElement.querySelector(".swiper-button-next")

        if (!this.showNavigation) {
            this.renderer.addClass(this.swiperButtonPrev, "hide-navigation")
            this.renderer.addClass(this.swiperButtonNext, "hide-navigation")
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes || !changes.showNavigation || changes.showNavigation.firstChange) return

        if (changes.showNavigation.currentValue) {
            this.renderer.removeClass(this.swiperButtonPrev, "hide-navigation")
            this.renderer.removeClass(this.swiperButtonNext, "hide-navigation")
        } else {
            this.renderer.addClass(this.swiperButtonPrev, "hide-navigation")
            this.renderer.addClass(this.swiperButtonNext, "hide-navigation")
        }
    }

    emitSelectedSubject(data, subject: CHNode) {
        if (!data || !data.isActive || !subject) return
        this.subjectSelected = true
        this.selectedSubject.emit({ subject, isSlideChangeEvent: false })
    }

    onSlideChange(event) {
        if (!event) return

        if (!this.subjectSelected) return
        this.zone.run(() => {
            const index = event.realIndex
            const subject = this.subjectTree[index]
            this.selectedSubject.emit({ subject, isSlideChangeEvent: true })
        })
    }
}
